const createTypography = (theme) => ({
  fontFamily: ['Poppins', 'Open Sans'].join(','),
  seenc_menu: {
    fontFamily: 'Poppins, Open Sans',
    fontWeight: 500,
    fontSize: '14px',
    letterSpacing: '-0.05px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: theme.palette.secondary.main,
  },
  seenc_menu_footer: {
    fontFamily: 'Poppins, Open Sans',
    fontWeight: 500,
    fontSize: '12px',
    letterSpacing: '-0.05px',
  },
  seenc_default: {
    fontFamily: 'Poppins, Open Sans',
    fontWeight: 500,
    fontSize: '13px',
    lineHeight: '13px',
    color: theme.palette.text.main,
    '&::placeholder': {
      color: theme.palette.text.main,
      opacity: 0.6,
    },
  },
  seenc_title: {
    fontFamily: 'Poppins, Open Sans',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '16px',
  },
  seenc_subtitle: {
    fontFamily: 'Poppins, Open Sans',
    fontWeight: 500,
    fontSize: '11px',
    lineHeight: '11px',
    color: theme.palette.text.secondary,
  },
  seenc_table_header_title: {
    fontFamily: 'Poppins, Open Sans',
    fontWeight: 500,
    fontSize: '13px',
    lineHeight: '13px',
  },
  seenc_table_header_subtitle: {
    fontFamily: 'Poppins, Open Sans',
    fontWeight: 500,
    fontSize: '13px',
    lineHeight: '13px',
  },
  seenc_table_body: {
    fontFamily: 'Poppins, Open Sans',
    fontWeight: 500,
    fontSize: '13px',
    lineHeight: '13px',
    color: theme.palette.text.main,
  },
  seenc_table_body_emphasis: {
    fontFamily: 'Poppins, Open Sans',
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '18px',
    color: theme.palette.text.main,
  },
  seenc_table_body_info: {
    fontFamily: 'Poppins, Open Sans',
    fontWeight: 500,
    fontSize: '10px',
    lineHeight: '10px',
    whiteSpace: 'nowrap',
    color: theme.palette.text.secondary,
  },
  seenc_avatar: {
    fontFamily: 'Poppins, Open Sans',
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '18px',
  },
  seenc_button: {
    fontFamily: 'Poppins, Open Sans',
    fontWeight: 500,
    fontSize: '13px',
    lineHeight: '13px',
  },
  seenc_big_number: {
    fontFamily: 'Poppins, Open Sans',
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: '24px',
  },
});

export default createTypography;
